<template>
  <v-text-field type="number" :value="value" @input="$emit('input', $event)" @change="$emit('change', $event)" />
</template>

<script>
export default {
  name: 'dr-filter-numeric-field',

  props: ['value']
}
</script>